export default "__VITE_ASSET__Bkl6MeTM__"